import { useRef } from "react"

import Style from "./style"

import usePostManagerLogin from "entity/auth/usePostManagerLogin"
import usePostAdminLogin from "entity/auth/usePostAdminLogin"

import DefaultButton from "shared/ui/DefaultButton"
import logo from "shared/asset/logo.svg"

const Login = () => {
    const idRef = useRef()
    const pwRef = useRef()

    const [clickManagerLogin] = usePostManagerLogin(idRef, pwRef)
    const [clickAdminLogin] = usePostAdminLogin(idRef, pwRef)

    return (
        <Style.Wrapper>
            <Style.ContentDiv>
                <Style.LogoImg src={logo} />
                <Style.FormDiv>
                    <input ref={idRef} placeholder="아이디" />
                    <input ref={pwRef} type="password" placeholder="비밀번호" />
                    <Style.ButtonDiv>
                        <DefaultButton clickEvent={clickManagerLogin}>매니저 계정 로그인</DefaultButton>
                        <DefaultButton clickEvent={clickAdminLogin}>관리자 계정 로그인</DefaultButton>
                    </Style.ButtonDiv>
                </Style.FormDiv>
            </Style.ContentDiv>
        </Style.Wrapper>
    )
}

export default Login